module.exports = __webpack_public_path__ + "static/media/CloudStorage.8deca3eb.png";